// material-ui
import { Typography, Switch, Table, TableBody, TableCell, TableRow, Alert, TextField } from '@mui/material';

// project import
import MainCard from 'components/MainCard';
import React from 'react';
import { getRequest, postRequest } from 'utils/apiRequest';
import { Input, Button, FormHelperText, } from '@mui/material';
// third party
import * as Yup from 'yup';
import { Formik } from 'formik';
import { LoadingButton } from '@mui/lab';

// ==============================|| SAMPLE PAGE ||============================== //

const SettingsSchema = Yup.object().shape({

    company_name: Yup.string().max(75).required('Company name is required'),
    contact_phone: Yup.string().max(15).required('Contact Phone is required'),
    contact_email: Yup.string().max(100).required('Contact email is required'),
    domain_name: Yup.string().max(100).required('Domain name is required'),
    language_code: Yup.string().max(5).required('Language code is required'),
    currency_code: Yup.string().max(5).required('Currency code is required'),
    allow_holidays: Yup.mixed().oneOf(['No', 'Yes']).required('Allow Holidays is required'),
    // default_latency: Yup.string().max(5).required('Default latency'),
    // theme_primary: Yup.string().min(7).max(7).required('Theme primary color is required'),
    // theme_secondary: Yup.string().min(7).max(7).required('Theme secondary color is required'),
})

const AccountSettings = () => {
    const [settings, setSettings] = React.useState([]);
    const [success, setSuccess] = React.useState(false);
    React.useEffect(() => {
        getRequest('/account/settings').then((d) => {
            setSettings(d);
        })
    }, []);

    return <>{settings.length > 0 ? (<Formik
        initialValues={{
            company_name: settings[0].value,
            contact_phone: settings[1].value,
            contact_email: settings[2].value,
            domain_name: settings[3].value,
            // default_latency: settings[4].value,
            // theme_primary: settings[5].value,
            // theme_secondary: settings[6].value,
            language_code: settings[4].value,
            currency_code: settings[5].value,
            allow_holidays: settings[6].value,
            submit: null
        }}
        validationSchema={SettingsSchema}
        onSubmit={(values, { setErrors, setStatus, setSubmitting }) => {
            setSuccess(false);
            setSubmitting(true);
            let formData = new FormData();
            Object.keys(values).forEach((k) => {
                formData.append(k, values[k]);
            })
            postRequest('/account/settings/update', formData).then(d => {
                setSuccess(true);
            }).finally(() => {
                setSubmitting(false);
            })
        }}>
        {({ errors, handleBlur, handleChange, handleSubmit, isSubmitting, touched, values }) => (
            <form noValidate onSubmit={handleSubmit}>
                <MainCard title="Account Settings">
                    {success && (
                        <Alert severity="success">Account settings saved</Alert>
                    )}
                    <Table>
                        <TableBody>
                            {settings.map((setting, i) => {
                                return (<TableRow key={i}>
                                    <TableCell style={{ width: 200 }}>
                                        {setting.name}
                                        {setting.id.indexOf('theme_') > -1 && (<>
                                            <input type="color" disabled value={values[setting.id]} style={{float: 'right'}} />
                                        </>)}
                                    </TableCell>
                                    <TableCell align="left">{values[setting.id]}
                                            {/* <TextField type="text" name={setting.id} value={values[setting.id]}
                                                onBlur={handleBlur}
                                                onChange={handleChange} />
                                            {touched[setting.id] && errors[setting.id] && (
                                                <FormHelperText error>
                                                    {errors[setting.id]}
                                                </FormHelperText>
                                            )} */}
                                    </TableCell>
                                </TableRow>
                                )
                            })}
                            {/* <TableRow>
                                <TableCell></TableCell>
                                <TableCell>
                                    <LoadingButton
                                        disableElevation
                                        disabled={isSubmitting}
                                        size="large"
                                        type="submit"
                                        variant="contained"
                                        color="primary"
                                        loading={isSubmitting}
                                    >
                                        Submit
                                    </LoadingButton>
                                </TableCell>
                            </TableRow> */}
                        </TableBody>
                    </Table>
                </MainCard>
            </form>)}
    </Formik>) : <></>}</>
}

export default AccountSettings;
